<template>
  <div>
    <p>Até logo 😉</p>
  </div>
</template>

<script>
export default {
  name: 'Logout',
  async mounted () {
    try {
      await this.$timetrack.force()
      await this.$http.get(process.env.VUE_APP_URL_APP + '/b/logout')
      this.$session.set('role', '')
      this.$session.set('logged', false)
      this.$router.push({name: 'Login'})
    } catch (e) {
      console.error(e)
      return false
    }
  }
}
</script>
